var city = {
  citycode: [],
  adcode: "430000",
  name: "湖南省",
  center: {
    lng: 112.982951,
    lat: 28.116007
  },
  districtList: [
    {
      citycode: "0730",
      adcode: "430600",
      name: "岳阳市",
      center: {
        lng: 113.128922,
        lat: 29.35648
      },
      districtList: [
        {
          citycode: "0730",
          adcode: "430623",
          name: "华容县",
          center: {
            lng: 112.540448,
            lat: 29.530775
          }
        },
        {
          citycode: "0730",
          adcode: "430603",
          name: "云溪区",
          center: {
            lng: 113.272312,
            lat: 29.472745
          }
        },
        {
          citycode: "0730",
          adcode: "430602",
          name: "岳阳楼区",
          center: {
            lng: 113.129362,
            lat: 29.371356
          }
        },
        {
          citycode: "0730",
          adcode: "430626",
          name: "平江县",
          center: {
            lng: 113.581296,
            lat: 28.702018
          }
        },
        {
          citycode: "0730",
          adcode: "430621",
          name: "岳阳县",
          center: {
            lng: 113.116152,
            lat: 29.144681
          }
        },
        {
          citycode: "0730",
          adcode: "430611",
          name: "君山区",
          center: {
            lng: 113.006434,
            lat: 29.461017
          }
        },
        {
          citycode: "0730",
          adcode: "430682",
          name: "临湘市",
          center: {
            lng: 113.450461,
            lat: 29.476687
          }
        },
        {
          citycode: "0730",
          adcode: "430681",
          name: "汨罗市",
          center: {
            lng: 113.067097,
            lat: 28.806937
          }
        },
        {
          citycode: "0730",
          adcode: "430624",
          name: "湘阴县",
          center: {
            lng: 112.909248,
            lat: 28.690123
          }
        }
      ]
    },
    {
      citycode: "0745",
      adcode: "431200",
      name: "怀化市",
      center: {
        lng: 110.001598,
        lat: 27.569813
      },
      districtList: [
        {
          citycode: "0745",
          adcode: "431228",
          name: "芷江侗族自治县",
          center: {
            lng: 109.684696,
            lat: 27.443429
          }
        },
        {
          citycode: "0745",
          adcode: "431230",
          name: "通道侗族自治县",
          center: {
            lng: 109.784409,
            lat: 26.158032
          }
        },
        {
          citycode: "0745",
          adcode: "431222",
          name: "沅陵县",
          center: {
            lng: 110.393782,
            lat: 28.452103
          }
        },
        {
          citycode: "0745",
          adcode: "431223",
          name: "辰溪县",
          center: {
            lng: 110.183159,
            lat: 28.006235
          }
        },
        {
          citycode: "0745",
          adcode: "431225",
          name: "会同县",
          center: {
            lng: 109.734724,
            lat: 26.887156
          }
        },
        {
          citycode: "0745",
          adcode: "431224",
          name: "溆浦县",
          center: {
            lng: 110.594419,
            lat: 27.908869
          }
        },
        {
          citycode: "0745",
          adcode: "431229",
          name: "靖州苗族侗族自治县",
          center: {
            lng: 109.696249,
            lat: 26.575111
          }
        },
        {
          citycode: "0745",
          adcode: "431226",
          name: "麻阳苗族自治县",
          center: {
            lng: 109.817703,
            lat: 27.857666
          }
        },
        {
          citycode: "0745",
          adcode: "431221",
          name: "中方县",
          center: {
            lng: 109.945436,
            lat: 27.440554
          }
        },
        {
          citycode: "0745",
          adcode: "431202",
          name: "鹤城区",
          center: {
            lng: 110.040099,
            lat: 27.578581
          }
        },
        {
          citycode: "0745",
          adcode: "431281",
          name: "洪江市",
          center: {
            lng: 109.836475,
            lat: 27.209385
          }
        },
        {
          citycode: "0745",
          adcode: "431227",
          name: "新晃侗族自治县",
          center: {
            lng: 109.174808,
            lat: 27.352094
          }
        }
      ]
    },
    {
      citycode: "0743",
      adcode: "433100",
      name: "湘西土家族苗族自治州",
      center: {
        lng: 109.737428,
        lat: 28.312592
      },
      districtList: [
        {
          citycode: "0743",
          adcode: "433127",
          name: "永顺县",
          center: {
            lng: 109.857142,
            lat: 28.979819
          }
        },
        {
          citycode: "0743",
          adcode: "433125",
          name: "保靖县",
          center: {
            lng: 109.660433,
            lat: 28.699939
          }
        },
        {
          citycode: "0743",
          adcode: "433101",
          name: "吉首市",
          center: {
            lng: 109.698348,
            lat: 28.261948
          }
        },
        {
          citycode: "0743",
          adcode: "433126",
          name: "古丈县",
          center: {
            lng: 109.95072,
            lat: 28.616971
          }
        },
        {
          citycode: "0743",
          adcode: "433122",
          name: "泸溪县",
          center: {
            lng: 110.219619,
            lat: 28.216109
          }
        },
        {
          citycode: "0743",
          adcode: "433130",
          name: "龙山县",
          center: {
            lng: 109.443974,
            lat: 29.457623
          }
        },
        {
          citycode: "0743",
          adcode: "433124",
          name: "花垣县",
          center: {
            lng: 109.482378,
            lat: 28.57191
          }
        },
        {
          citycode: "0743",
          adcode: "433123",
          name: "凤凰县",
          center: {
            lng: 109.580815,
            lat: 27.957441
          }
        }
      ]
    },
    {
      citycode: "0737",
      adcode: "430900",
      name: "益阳市",
      center: {
        lng: 112.355994,
        lat: 28.554853
      },
      districtList: [
        {
          citycode: "0737",
          adcode: "430902",
          name: "资阳区",
          center: {
            lng: 112.324286,
            lat: 28.59149
          }
        },
        {
          citycode: "0737",
          adcode: "430922",
          name: "桃江县",
          center: {
            lng: 112.156432,
            lat: 28.518215
          }
        },
        {
          citycode: "0737",
          adcode: "430923",
          name: "安化县",
          center: {
            lng: 111.213296,
            lat: 28.374223
          }
        },
        {
          citycode: "0737",
          adcode: "430921",
          name: "南县",
          center: {
            lng: 112.396323,
            lat: 29.362396
          }
        },
        {
          citycode: "0737",
          adcode: "430981",
          name: "沅江市",
          center: {
            lng: 112.354657,
            lat: 28.845755
          }
        },
        {
          citycode: "0737",
          adcode: "430903",
          name: "赫山区",
          center: {
            lng: 112.373895,
            lat: 28.58011
          }
        }
      ]
    },
    {
      citycode: "0734",
      adcode: "430400",
      name: "衡阳市",
      center: {
        lng: 112.572016,
        lat: 26.894216
      },
      districtList: [
        {
          citycode: "0734",
          adcode: "430412",
          name: "南岳区",
          center: {
            lng: 112.737678,
            lat: 27.231846
          }
        },
        {
          citycode: "0734",
          adcode: "430423",
          name: "衡山县",
          center: {
            lng: 112.868361,
            lat: 27.230225
          }
        },
        {
          citycode: "0734",
          adcode: "430421",
          name: "衡阳县",
          center: {
            lng: 112.370649,
            lat: 26.970258
          }
        },
        {
          citycode: "0734",
          adcode: "430407",
          name: "石鼓区",
          center: {
            lng: 112.597937,
            lat: 26.944257
          }
        },
        {
          citycode: "0734",
          adcode: "430406",
          name: "雁峰区",
          center: {
            lng: 112.613914,
            lat: 26.840335
          }
        },
        {
          citycode: "0734",
          adcode: "430405",
          name: "珠晖区",
          center: {
            lng: 112.620653,
            lat: 26.894796
          }
        },
        {
          citycode: "0734",
          adcode: "430408",
          name: "蒸湘区",
          center: {
            lng: 112.567333,
            lat: 26.912388
          }
        },
        {
          citycode: "0734",
          adcode: "430482",
          name: "常宁市",
          center: {
            lng: 112.399894,
            lat: 26.421717
          }
        },
        {
          citycode: "0734",
          adcode: "430424",
          name: "衡东县",
          center: {
            lng: 112.953113,
            lat: 27.081086
          }
        },
        {
          citycode: "0734",
          adcode: "430426",
          name: "祁东县",
          center: {
            lng: 112.090319,
            lat: 26.799284
          }
        },
        {
          citycode: "0734",
          adcode: "430481",
          name: "耒阳市",
          center: {
            lng: 112.859806,
            lat: 26.422149
          }
        },
        {
          citycode: "0734",
          adcode: "430422",
          name: "衡南县",
          center: {
            lng: 112.677572,
            lat: 26.739665
          }
        }
      ]
    },
    {
      citycode: "0732",
      adcode: "430300",
      name: "湘潭市",
      center: {
        lng: 112.945439,
        lat: 27.83136
      },
      districtList: [
        {
          citycode: "0732",
          adcode: "430304",
          name: "岳塘区",
          center: {
            lng: 112.969444,
            lat: 27.872013
          }
        },
        {
          citycode: "0732",
          adcode: "430302",
          name: "雨湖区",
          center: {
            lng: 112.907334,
            lat: 27.856115
          }
        },
        {
          citycode: "0732",
          adcode: "430382",
          name: "韶山市",
          center: {
            lng: 112.525364,
            lat: 27.914796
          }
        },
        {
          citycode: "0732",
          adcode: "430321",
          name: "湘潭县",
          center: {
            lng: 112.950767,
            lat: 27.779669
          }
        },
        {
          citycode: "0732",
          adcode: "430381",
          name: "湘乡市",
          center: {
            lng: 112.550268,
            lat: 27.718655
          }
        }
      ]
    },
    {
      citycode: "0746",
      adcode: "431100",
      name: "永州市",
      center: {
        lng: 111.613482,
        lat: 26.419861
      },
      districtList: [
        {
          citycode: "0746",
          adcode: "431122",
          name: "东安县",
          center: {
            lng: 111.315893,
            lat: 26.392173
          }
        },
        {
          citycode: "0746",
          adcode: "431103",
          name: "冷水滩区",
          center: {
            lng: 111.592373,
            lat: 26.461313
          }
        },
        {
          citycode: "0746",
          adcode: "431102",
          name: "零陵区",
          center: {
            lng: 111.629806,
            lat: 26.222278
          }
        },
        {
          citycode: "0746",
          adcode: "431126",
          name: "宁远县",
          center: {
            lng: 111.945925,
            lat: 25.570817
          }
        },
        {
          citycode: "0746",
          adcode: "431128",
          name: "新田县",
          center: {
            lng: 112.203396,
            lat: 25.903965
          }
        },
        {
          citycode: "0746",
          adcode: "431123",
          name: "双牌县",
          center: {
            lng: 111.659967,
            lat: 25.961909
          }
        },
        {
          citycode: "0746",
          adcode: "431125",
          name: "江永县",
          center: {
            lng: 111.343543,
            lat: 25.274461
          }
        },
        {
          citycode: "0746",
          adcode: "431124",
          name: "道县",
          center: {
            lng: 111.600866,
            lat: 25.526282
          }
        },
        {
          citycode: "0746",
          adcode: "431129",
          name: "江华瑶族自治县",
          center: {
            lng: 111.57951,
            lat: 25.185257
          }
        },
        {
          citycode: "0746",
          adcode: "431181",
          name: "祁阳市",
          center: {
            lng: 111.840253,
            lat: 26.580292
          }
        },
        {
          citycode: "0746",
          adcode: "431127",
          name: "蓝山县",
          center: {
            lng: 112.195842,
            lat: 25.369575
          }
        }
      ]
    },
    {
      citycode: "0735",
      adcode: "431000",
      name: "郴州市",
      center: {
        lng: 113.015517,
        lat: 25.770117
      },
      districtList: [
        {
          citycode: "0735",
          adcode: "431081",
          name: "资兴市",
          center: {
            lng: 113.235841,
            lat: 25.977226
          }
        },
        {
          citycode: "0735",
          adcode: "431027",
          name: "桂东县",
          center: {
            lng: 113.944792,
            lat: 26.077609
          }
        },
        {
          citycode: "0735",
          adcode: "431025",
          name: "临武县",
          center: {
            lng: 112.563833,
            lat: 25.276459
          }
        },
        {
          citycode: "0735",
          adcode: "431003",
          name: "苏仙区",
          center: {
            lng: 113.042364,
            lat: 25.799624
          }
        },
        {
          citycode: "0735",
          adcode: "431023",
          name: "永兴县",
          center: {
            lng: 113.116587,
            lat: 26.127155
          }
        },
        {
          citycode: "0735",
          adcode: "431024",
          name: "嘉禾县",
          center: {
            lng: 112.379216,
            lat: 25.616025
          }
        },
        {
          citycode: "0735",
          adcode: "431028",
          name: "安仁县",
          center: {
            lng: 113.269703,
            lat: 26.708569
          }
        },
        {
          citycode: "0735",
          adcode: "431002",
          name: "北湖区",
          center: {
            lng: 113.010606,
            lat: 25.784632
          }
        },
        {
          citycode: "0735",
          adcode: "431021",
          name: "桂阳县",
          center: {
            lng: 112.733804,
            lat: 25.75382
          }
        },
        {
          citycode: "0735",
          adcode: "431026",
          name: "汝城县",
          center: {
            lng: 113.685193,
            lat: 25.533024
          }
        },
        {
          citycode: "0735",
          adcode: "431022",
          name: "宜章县",
          center: {
            lng: 112.948806,
            lat: 25.40059
          }
        }
      ]
    },
    {
      citycode: "0733",
      adcode: "430200",
      name: "株洲市",
      center: {
        lng: 113.132783,
        lat: 27.828862
      },
      districtList: [
        {
          citycode: "0733",
          adcode: "430202",
          name: "荷塘区",
          center: {
            lng: 113.173169,
            lat: 27.856314
          }
        },
        {
          citycode: "0733",
          adcode: "430223",
          name: "攸县",
          center: {
            lng: 113.397152,
            lat: 27.01516
          }
        },
        {
          citycode: "0733",
          adcode: "430225",
          name: "炎陵县",
          center: {
            lng: 113.772665,
            lat: 26.489847
          }
        },
        {
          citycode: "0733",
          adcode: "430211",
          name: "天元区",
          center: {
            lng: 113.082227,
            lat: 27.826738
          }
        },
        {
          citycode: "0733",
          adcode: "430212",
          name: "渌口区",
          center: {
            lng: 113.143832,
            lat: 27.699361
          }
        },
        {
          citycode: "0733",
          adcode: "430203",
          name: "芦淞区",
          center: {
            lng: 113.153455,
            lat: 27.785198
          }
        },
        {
          citycode: "0733",
          adcode: "430204",
          name: "石峰区",
          center: {
            lng: 113.117763,
            lat: 27.875513
          }
        },
        {
          citycode: "0733",
          adcode: "430224",
          name: "茶陵县",
          center: {
            lng: 113.537907,
            lat: 26.777957
          }
        },
        {
          citycode: "0733",
          adcode: "430281",
          name: "醴陵市",
          center: {
            lng: 113.497119,
            lat: 27.6457
          }
        }
      ]
    },
    {
      citycode: "0744",
      adcode: "430800",
      name: "张家界市",
      center: {
        lng: 110.478887,
        lat: 29.117343
      },
      districtList: [
        {
          citycode: "0744",
          adcode: "430802",
          name: "永定区",
          center: {
            lng: 110.537379,
            lat: 29.119662
          }
        },
        {
          citycode: "0744",
          adcode: "430822",
          name: "桑植县",
          center: {
            lng: 110.204804,
            lat: 29.414112
          }
        },
        {
          citycode: "0744",
          adcode: "430811",
          name: "武陵源区",
          center: {
            lng: 110.550309,
            lat: 29.345721
          }
        },
        {
          citycode: "0744",
          adcode: "430821",
          name: "慈利县",
          center: {
            lng: 111.139424,
            lat: 29.430429
          }
        }
      ]
    },
    {
      citycode: "0736",
      adcode: "430700",
      name: "常德市",
      center: {
        lng: 111.69905,
        lat: 29.031446
      },
      districtList: [
        {
          citycode: "0736",
          adcode: "430703",
          name: "鼎城区",
          center: {
            lng: 111.679896,
            lat: 29.017596
          }
        },
        {
          citycode: "0736",
          adcode: "430723",
          name: "澧县",
          center: {
            lng: 111.758806,
            lat: 29.633138
          }
        },
        {
          citycode: "0736",
          adcode: "430781",
          name: "津市市",
          center: {
            lng: 111.877957,
            lat: 29.606512
          }
        },
        {
          citycode: "0736",
          adcode: "430721",
          name: "安乡县",
          center: {
            lng: 112.171107,
            lat: 29.41131
          }
        },
        {
          citycode: "0736",
          adcode: "430724",
          name: "临澧县",
          center: {
            lng: 111.647547,
            lat: 29.440813
          }
        },
        {
          citycode: "0736",
          adcode: "430702",
          name: "武陵区",
          center: {
            lng: 111.683043,
            lat: 29.055332
          }
        },
        {
          citycode: "0736",
          adcode: "430725",
          name: "桃源县",
          center: {
            lng: 111.488985,
            lat: 28.90232
          }
        },
        {
          citycode: "0736",
          adcode: "430726",
          name: "石门县",
          center: {
            lng: 111.380056,
            lat: 29.584344
          }
        },
        {
          citycode: "0736",
          adcode: "430722",
          name: "汉寿县",
          center: {
            lng: 111.970725,
            lat: 28.906063
          }
        }
      ]
    },
    {
      citycode: "0731",
      adcode: "430100",
      name: "长沙市",
      center: {
        lng: 112.938882,
        lat: 28.228304
      },
      districtList: [
        {
          citycode: "0731",
          adcode: "430104",
          name: "岳麓区",
          center: {
            lng: 112.930116,
            lat: 28.234202
          }
        },
        {
          citycode: "0731",
          adcode: "430121",
          name: "长沙县",
          center: {
            lng: 113.080555,
            lat: 28.246821
          }
        },
        {
          citycode: "0731",
          adcode: "430102",
          name: "芙蓉区",
          center: {
            lng: 113.032605,
            lat: 28.185351
          }
        },
        {
          citycode: "0731",
          adcode: "430103",
          name: "天心区",
          center: {
            lng: 112.98978,
            lat: 28.114544
          }
        },
        {
          citycode: "0731",
          adcode: "430111",
          name: "雨花区",
          center: {
            lng: 113.03853,
            lat: 28.135795
          }
        },
        {
          citycode: "0731",
          adcode: "430181",
          name: "浏阳市",
          center: {
            lng: 113.64328,
            lat: 28.163866
          }
        },
        {
          citycode: "0731",
          adcode: "430182",
          name: "宁乡市",
          center: {
            lng: 112.551887,
            lat: 28.277709
          }
        },
        {
          citycode: "0731",
          adcode: "430112",
          name: "望城区",
          center: {
            lng: 112.83125,
            lat: 28.353221
          }
        },
        {
          citycode: "0731",
          adcode: "430105",
          name: "开福区",
          center: {
            lng: 112.985284,
            lat: 28.257286
          }
        }
      ]
    },
    {
      citycode: "0739",
      adcode: "430500",
      name: "邵阳市",
      center: {
        lng: 111.467855,
        lat: 27.239528
      },
      districtList: [
        {
          citycode: "0739",
          adcode: "430524",
          name: "隆回县",
          center: {
            lng: 111.032437,
            lat: 27.113978
          }
        },
        {
          citycode: "0739",
          adcode: "430502",
          name: "双清区",
          center: {
            lng: 111.496946,
            lat: 27.232286
          }
        },
        {
          citycode: "0739",
          adcode: "430511",
          name: "北塔区",
          center: {
            lng: 111.451988,
            lat: 27.246244
          }
        },
        {
          citycode: "0739",
          adcode: "430523",
          name: "邵阳县",
          center: {
            lng: 111.273872,
            lat: 26.990785
          }
        },
        {
          citycode: "0739",
          adcode: "430503",
          name: "大祥区",
          center: {
            lng: 111.438892,
            lat: 27.222078
          }
        },
        {
          citycode: "0739",
          adcode: "430527",
          name: "绥宁县",
          center: {
            lng: 110.155532,
            lat: 26.582027
          }
        },
        {
          citycode: "0739",
          adcode: "430582",
          name: "邵东市",
          center: {
            lng: 111.744268,
            lat: 27.259812
          }
        },
        {
          citycode: "0739",
          adcode: "430528",
          name: "新宁县",
          center: {
            lng: 110.857294,
            lat: 26.432913
          }
        },
        {
          citycode: "0739",
          adcode: "430581",
          name: "武冈市",
          center: {
            lng: 110.632286,
            lat: 26.727414
          }
        },
        {
          citycode: "0739",
          adcode: "430525",
          name: "洞口县",
          center: {
            lng: 110.575962,
            lat: 27.060274
          }
        },
        {
          citycode: "0739",
          adcode: "430529",
          name: "城步苗族自治县",
          center: {
            lng: 110.322239,
            lat: 26.390598
          }
        },
        {
          citycode: "0739",
          adcode: "430522",
          name: "新邵县",
          center: {
            lng: 111.458656,
            lat: 27.320917
          }
        }
      ]
    },
    {
      citycode: "0738",
      adcode: "431300",
      name: "娄底市",
      center: {
        lng: 111.994468,
        lat: 27.699838
      },
      districtList: [
        {
          citycode: "0738",
          adcode: "431321",
          name: "双峰县",
          center: {
            lng: 112.174623,
            lat: 27.457437
          }
        },
        {
          citycode: "0738",
          adcode: "431302",
          name: "娄星区",
          center: {
            lng: 112.001922,
            lat: 27.730208
          }
        },
        {
          citycode: "0738",
          adcode: "431382",
          name: "涟源市",
          center: {
            lng: 111.663837,
            lat: 27.693813
          }
        },
        {
          citycode: "0738",
          adcode: "431322",
          name: "新化县",
          center: {
            lng: 111.327674,
            lat: 27.725416
          }
        },
        {
          citycode: "0738",
          adcode: "431381",
          name: "冷水江市",
          center: {
            lng: 111.459199,
            lat: 27.656017
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/hunan.js